module.exports = __webpack_public_path__ + "static/media/28.f59ae377.jpg";